import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { Marker, TileLayer } from "react-leaflet";
import { useMapEvents } from "react-leaflet/hooks";

export default function MapOrder(props) {
  const [markerLatLng, setMarkerLatLng] = useState([
    props.myLocations.latitude ? props.myLocations.latitude : 35.7009,
    props.myLocations.longitude ? props.myLocations.longitude : 51.391241,
  ]);

  useEffect(() => {
    if (props.myLocations) {
      map.setZoom(11);
      setMarkerLatLng([
        props.myLocations.latitude ? props.myLocations.latitude : 35.7009,
        props.myLocations.longitude ? props.myLocations.longitude : 51.391241,
      ]);
    }
  }, [props.myLocations]);

  const map = useMapEvents({
    click: (event) => {
      props.setMyLocations({
        ...props.myLocations,
        latitude: event.latlng.lat,
        longitude: event.latlng.lng,
      });
      setMarkerLatLng([event.latlng.lat, event.latlng.lng]);
    },
  });

  L.DomUtil.addClass(map._container, "crosshair-cursor-enabled");

  const myIcon = new L.Icon({
    iconUrl: "/static/img/IcoNLocatioN.svg",
    iconRetinaUrl: "/static/img/IcoNLocatioN.svg",
    popupAnchor: [-0, -0],
    iconSize: [35, 45],
    iconAnchor: [15, 35],
  });

  const tileLayerUrl = window.ENV.tileLayerUrl
    ? window.ENV.tileLayerUrl
    : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

  return (
    <>
      <TileLayer
        attribution="&copy; OpenStreetMap contributors"
        url={tileLayerUrl}
      ></TileLayer>
      {markerLatLng && <Marker position={markerLatLng} icon={myIcon}></Marker>}
    </>
  );
}
